import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SearchComponent } from './search.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SearchComponent],
  imports: [CommonModule, TranslateModule, RouterModule],
  exports: [SearchComponent],
  providers: []
})
export class SearchModule {}



// WEBPACK FOOTER //
// ./src/app/modules/search/search.module.ts